export default __webpack_public_path__ + "static/media/review9.f5910b18.jpg";